////////////*Feature:Drag and Drop///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

function resetDnd($slide, slide) {
	$slide = $slide ? $slide : globalVar.$curSlide;
	slide = slide ? slide : globalVar.curSlide;
	var $draggables = $slide.find('.draggable');
	var $droppables = $slide.find('.droppable');
	var dndInfo = slides[slide].dnd ? slides[slide].dnd : {};

	// animate back to start position and reset all position storage to the original.  Remove dnd2 class
	$draggables.each(function (idx, draggable) {
		var currentDraggableData = dndInfo.draggableData[draggable.id];
		var startPosition = currentDraggableData.originalPosition;
		$(draggable).animate(startPosition, 500);
		currentDraggableData.currentPosition = startPosition;
		currentDraggableData.previousPosition = startPosition;
		currentDraggableData.currentDropID = '';
		if (slides[slide].dnd.type === 'dnd_2') {
			$(draggable).fadeIn().removeClass('shrink');
		}
		if (slides[slide].dnd.type === 'line') {
			$(draggable).fadeIn().removeClass('shrink');
			resetLeaderLines();
		}
	});
	// wipe contained draggable info
	$droppables.each(function (idx, droppable) {
		dndInfo.droppableData[droppable.id].containedDraggables = [];
		dndInfo.droppableData[droppable.id].lastDraggableAccepted = [];
	});
	return true;
}

function dndFunction() {
	var $draggables = globalVar.$curSlide.find('.draggable');
	var $droppables = globalVar.$curSlide.find('.droppable');

	// The reason we wait until the slide is visited to initialize the dnd is because the positioning of the draggables will be incorrect when the reveal slide is hidden.

	if (!slides[globalVar.curSlide].visited) {
		var slide = globalVar.curSlide;
		var $slide = globalVar.$curSlide;
		addToFunctionKey(slides[slide], 'onExitAction', function () {
			resetDnd($slide, slide);
		});
		var dndInfo = slides[globalVar.curSlide].dnd ? slides[globalVar.curSlide].dnd : {};
		dndInfo.draggableData = dndInfo.draggableData ? dndInfo.draggableData : {};
		dndInfo.droppableData = dndInfo.droppableData ? dndInfo.droppableData : {};

		dndInfo.type = dndInfo.type ? dndInfo.type : 'dnd_1';
		if (dndInfo.type === 'line') {
			window.leaderlines[globalVar.curSlide] = {};

			addToFunctionKey(slides[slide], 'onExitAction', function () {
				quickResetLeaderLines(slide);
			});
		}
		dndInfo.snapping = dndInfo.snapping ? dndInfo.snapping : true;
		dndInfo.alignmentOnDrop = dndInfo.alignmentOnDrop ? dndInfo.alignmentOnDrop : 'snapping';
		// First time to the slide store the top and left positions of the draggables
		$draggables.each(function (idx, draggable) {
			dndInfo.draggableData[draggable.id] = dndInfo.draggableData[draggable.id]
				? dndInfo.draggableData[draggable.id]
				: {};
			var initialTop =
				((parseInt($(draggable).css('top')) / $(draggable).parent().height()) * 100).toString() + '%';
			var initialLeft =
				((parseInt($(draggable).css('left')) / $(draggable).parent().width()) * 100).toString() + '%';

			var alignment = dndInfo.draggableData[draggable.id].alignmentOnDrop
				? dndInfo.draggableData[draggable.id].alignmentOnDrop
				: '';

			if (dndInfo.type === 'line') {
				var correspondingLeaderLineName = globalVar.curSlide + '_leaderline_' + draggable.id;

				var lineName = globalVar.curSlide + '_leaderline_' + draggable.id;
				var startElement = document.getElementById(
					slides[globalVar.curSlide].dnd.leaderLineSetup[draggable.id].startElement
				);
				var endElement = document.getElementById(draggable.id);
				// console.log(startElement, lineName, endElement);
				window.leaderlines[globalVar.curSlide][lineName] = new LeaderLine(startElement, endElement, {
					startPlug: slides[globalVar.curSlide].dnd.leaderLineSetup.startPlug || 'behind',
					startSocket: slides[globalVar.curSlide].dnd.leaderLineSetup.startSocket || 'auto',
					startPlugColor: slides[globalVar.curSlide].dnd.leaderLineSetup.startPlugColor || 'auto',
					startPlugSize: slides[globalVar.curSlide].dnd.leaderLineSetup.startPlugSize || 1,
					startPlugOutline: slides[globalVar.curSlide].dnd.leaderLineSetup.startPlugOutline || false,
					startPlugOutlineColor:
						slides[globalVar.curSlide].dnd.leaderLineSetup.startPlugOutlineColor || 'auto',
					startPlugOutlineSize: slides[globalVar.curSlide].dnd.leaderLineSetup.startPlugOutlineSize || 1,
					endPlugOutline: slides[globalVar.curSlide].dnd.leaderLineSetup.endPlugOutline || false,
					endPlugOutlineColor: slides[globalVar.curSlide].dnd.leaderLineSetup.endPlugOutlineColor || 'auto',
					endPlugOutlineSize: slides[globalVar.curSlide].dnd.leaderLineSetup.endPlugOutlineSize || 1,
					endPlugSize: slides[globalVar.curSlide].dnd.leaderLineSetup.endPlugSize || 1,
					endPlugColor: slides[globalVar.curSlide].dnd.leaderLineSetup.endPlugColor || 'auto',
					endSocket: slides[globalVar.curSlide].dnd.leaderLineSetup.endSocket || 'auto',
					endPlug: 'behind',
					hide: 'true',
					color: slides[globalVar.curSlide].dnd.leaderLineSetup.color || 'black',
					size: slides[globalVar.curSlide].dnd.leaderLineSetup.size || 4,
					path: slides[globalVar.curSlide].dnd.leaderLineSetup.path || 'fluid',
					dash: slides[globalVar.curSlide].dnd.leaderLineSetup.dash || false
				});
				window.leaderlines[globalVar.curSlide][lineName].originalEndPoint = endElement;
			}
			dndInfo.draggableData[draggable.id] = {
				originalPosition: {
					top: initialTop,
					left: initialLeft
				},
				currentPosition: {
					top: initialTop,
					left: initialLeft
				},
				previousPosition: {
					top: initialTop,
					left: initialLeft
				},
				currentDropID: '',
				alignmentOnDrop: alignment,
				correspondingLeaderLine: correspondingLeaderLineName
			};

			// makes dnd keyboard accessible
			$(draggable).attr('tabindex', '0');
			keyBoardAccess(draggable);
		});

		$droppables.each(function (idx, droppable) {
			// set defaults for answer and dropcounter if they are not provided, create place to store draggable info
			if (dndInfo.droppableData[droppable.id]) {
				var currentDroppableData = dndInfo.droppableData[droppable.id];
				var correctAnswer;
				if (currentDroppableData.answers || currentDroppableData.answers === 0) {
					correctAnswer = currentDroppableData.answers;
				} else {
					correctAnswer = [$($draggables[idx])[0].id];
				}
				var dropCount = currentDroppableData.dropCounter ? currentDroppableData.dropCounter : 1;
				var snapTo = currentDroppableData.snapTo;
				dndInfo.droppableData[droppable.id] = {
					answers: correctAnswer,
					containedDraggables: [],
					dropCounter: dropCount,
					lastDraggableAccepted: [],
					snapTo: snapTo
				};
			} else {
				dndInfo.droppableData[droppable.id] = {
					answers: [$($draggables[idx])[0].id],
					containedDraggables: [],
					dropCounter: 1,
					lastDraggableAccepted: []
				};
			}

			// necessary to make dnd keyboard accessible
			$(droppable).attr('tabindex', '-1');
		});

		// basic draggable initialize
		$draggables.draggable({
			drag: function (event, ui) {
				draggable = ui.helper[0];
				currentDraggableData = dndInfo.draggableData[draggable.id];
				if (slides[globalVar.curSlide].dnd.type === 'line') {
					window.leaderlines[globalVar.curSlide][currentDraggableData.correspondingLeaderLine]
						.position()
						.show();
				}
			},
			revert: function (validArea) {
				if (!validArea) {
					if (slides[globalVar.curSlide].dnd.type === 'line') {
						resetSpecificLeaderLine(currentDraggableData.correspondingLeaderLine);
					}
					return true;
				} else {
					return false;
				}
			},
			stack: '.draggable'
		});
		// attach custom events and options if provided
		if (dndInfo.draggableGroups) {
			for (group in dndInfo.draggableGroups) {
				if (dndInfo.draggableGroups[group].events) {
					for (action in dndInfo.draggableGroups[group].events) {
						$('#' + globalVar.curSlide + ' ' + group).on(
							action,
							dndInfo.draggableGroups[group].events[action]
						);
					}
				}
				if (dndInfo.draggableGroups[group].options) {
					$('#' + globalVar.curSlide + ' ' + group).draggable(
						'option',
						dndInfo.draggableGroups[group].options
					);
				}
			}
		}
		// basic droppable initialize
		$droppables.droppable({
			drop: function (event, ui) {
				handleDrop($(event.target), $(ui.draggable));
			}
		});
		// attach custom events and options if provided
		if (dndInfo.droppableGroups) {
			for (group in dndInfo.droppableGroups) {
				if (dndInfo.droppableGroups[group].events) {
					for (action in dndInfo.droppableGroups[group].events) {
						$('#' + globalVar.curSlide + ' ' + group).on(
							action,
							dndInfo.droppableGroups[group].events[action]
						);
					}
				}
				if (dndInfo.droppableGroups[group].options) {
					$('#' + globalVar.curSlide + ' ' + group).droppable(
						'option',
						dndInfo.droppableGroups[group].options
					);
				}
			}
		}
	}
	// moved reset dnd to exit action
	// else {
	// 	resetDnd();
	// }

	return true;
} //end dndFunction
function alignedPosition($droppable, $draggable) {
	var dndInfo = slides[globalVar.curSlide].dnd;
	var dragData = dndInfo.draggableData[$draggable[0].id];
	var newPosition = {
		top: 0,
		left: 0
	};
	var alignment = dragData.alignmentOnDrop ? dragData.alignmentOnDrop : dndInfo.alignmentOnDrop;
	switch (typeof alignment) {
		case 'string':
			switch (alignment) {
				case 'snapping':
					newPosition.top =
						((parseInt($droppable.css('top')) / $droppable.parent().height()) * 100).toString() + '%';
					newPosition.left =
						((parseInt($droppable.css('left')) / $droppable.parent().width()) * 100).toString() + '%';
					break;
				case 'fixed':
					newPosition.top =
						((parseInt($draggable.css('top')) / $('.reveal').height()) * 100).toString() + '%';
					newPosition.left =
						((parseInt($draggable.css('left')) / $('.reveal').width()) * 100).toString() + '%';
					break;
				case 'center':
					newPosition.top =
						(
							((parseInt($droppable.css('top')) + $droppable.height() / 2 - $draggable.height() / 2) /
								$droppable.parent().height()) *
							100
						).toString() + '%';
					newPosition.left =
						(
							((parseInt($droppable.css('left')) + $droppable.width() / 2 - $draggable.width() / 2) /
								$droppable.parent().width()) *
							100
						).toString() + '%';
					break;
				case 'h-center':
					newPosition.top =
						((parseInt($droppable.css('top')) / $droppable.parent().height()) * 100).toString() + '%';
					newPosition.left =
						(
							((parseInt($droppable.css('left')) + $droppable.width() / 2 - $draggable.width() / 2) /
								$droppable.parent().width()) *
							100
						).toString() + '%';
					break;
				case 'v-center':
					newPosition.top =
						(
							((parseInt($droppable.css('top')) + $droppable.height() / 2 - $draggable.height() / 2) /
								$droppable.parent().height()) *
							100
						).toString() + '%';
					newPosition.left =
						((parseInt($droppable.css('left')) / $droppable.parent().width()) * 100).toString() + '%';
					break;
				default:
					break;
			}
			break;
		case 'object':
			if (Array.isArray(alignment)) {
				if (alignment.length === 2) {
					switch (alignment[0]) {
						case 'v-center':
							newPosition.top =
								(
									((parseInt($droppable.css('top')) +
										$droppable.height() / 2 -
										$draggable.height() / 2) /
										$droppable.parent().height()) *
									100
								).toString() + '%';
							break;
						case 'top':
							newPosition.top =
								((parseInt($droppable.css('top')) / $droppable.parent().height()) * 100).toString() +
								'%';
							break;
						case 'middle':
							newPosition.top =
								(
									((parseInt($droppable.css('top')) + $droppable.height() / 2) /
										$droppable.parent().height()) *
									100
								).toString() + '%';
							break;
						case 'bottom':
							newPosition.top =
								(
									((parseInt($droppable.css('top')) + $droppable.height() - $draggable.height()) /
										$droppable.parent().height()) *
									100
								).toString() + '%';
							break;
						case 'under':
							newPosition.top =
								(
									((parseInt($droppable.css('top')) + $droppable.height()) /
										$droppable.parent().height()) *
									100
								).toString() + '%';
							break;
						case 'over':
							newPosition.top =
								(
									((parseInt($droppable.css('top')) - $draggable.height()) /
										$droppable.parent().height()) *
									100
								).toString() + '%';
							break;
						default:
							break;
					}

					switch (alignment[1]) {
						case 'h-center':
							newPosition.left =
								(
									((parseInt($droppable.css('left')) +
										$droppable.width() / 2 -
										$draggable.width() / 2) /
										$droppable.parent().width()) *
									100
								).toString() + '%';
							break;
						case 'left':
							newPosition.left =
								((parseInt($droppable.css('left')) / $droppable.parent().width()) * 100).toString() +
								'%';
							break;
						case 'middle':
							newPosition.left =
								(
									((parseInt($droppable.css('left')) + $droppable.width() / 2) /
										$droppable.parent().width()) *
									100
								).toString() + '%';
							break;
						case 'right':
							newPosition.left =
								(
									((parseInt($droppable.css('left')) + $droppable.width() - $draggable.width()) /
										$droppable.parent().width()) *
									100
								).toString() + '%';
							break;
						case 'outside-right':
							newPosition.left =
								(
									((parseInt($droppable.css('left')) + $droppable.width()) /
										$droppable.parent().width()) *
									100
								).toString() + '%';
							break;
						case 'outside-left':
							newPosition.left =
								(
									((parseInt($droppable.css('left')) - $draggable.width()) /
										$droppable.parent().width()) *
									100
								).toString() + '%';
							break;
						default:
							break;
					}
				}
			} else {
				newPosition = alignment;
			}
		default:
			break;
	}

	return newPosition;
}
//handle drop into valid drop area for all dnd types///
function handleDrop($droppable, $draggable) {
	var dndInfo = slides[globalVar.curSlide].dnd;
	var currentDropData = dndInfo.droppableData[$droppable[0].id];
	var currentDragData = dndInfo.draggableData[$draggable[0].id];

	// determine if a drop area can accept more draggables
	// var spaceAvailable = Object.keys(currentDropData.containedDraggables).length < currentDropData.dropCounter;
	var spaceAvailable = currentDropData.containedDraggables.length < currentDropData.dropCounter;

	if (spaceAvailable) {
		// remove draggable info from previous drop area if moving between droppables
		if (currentDragData.currentDropID) {
			var previousDropData = dndInfo.droppableData[currentDragData.currentDropID];
			if (previousDropData.containedDraggables.indexOf($draggable[0].id) > -1) {
				previousDropData.containedDraggables.splice(
					previousDropData.containedDraggables.indexOf($draggable[0].id),
					1
				);
			}
			if (previousDropData.lastDraggableAccepted.indexOf($draggable[0].id) > -1) {
				previousDropData.lastDraggableAccepted.splice(
					previousDropData.lastDraggableAccepted.indexOf($draggable[0].id),
					1
				);
			}
		}
		// add draggable id to the drop data
		currentDropData.containedDraggables.push($draggable[0].id);
		currentDropData.lastDraggableAccepted.push($draggable[0].id);
		// update draggable data
		currentDragData.currentDropID = $droppable[0].id;
		currentDragData.previousPosition = currentDragData.currentPosition;
		currentDragData.currentPosition = alignedPosition($droppable, $draggable);
		// handle movement based on dnd type
		if (dndInfo.type === 'dnd_2') {
			$draggable.addClass('shrink');
		} else if (dndInfo.type === 'line') {
			$draggable.addClass('shrink');

			window.leaderlines[globalVar.curSlide][currentDragData.correspondingLeaderLine].setOptions({
				endPlug: dndInfo.leaderLineSetup.endPlug,
				end: document.getElementById(currentDropData.snapTo || $droppable[0].id)
			});
		} else {
			$draggable.animate(currentDragData.currentPosition, 500);
		}
	} else {
		// revert draggable if dnd2
		if (dndInfo.type === 'dnd_2') {
			$draggable.animate(currentDragData.previousPosition, 500);
		} else if (dndInfo.type === 'line') {
			$draggable.animate(currentDragData.previousPosition, 500);
			resetSpecificLeaderLine(currentDragData.correspondingLeaderLine);
		} else {
			// handle swapping elements if dnd1. swaps last draggable dropped with the current drop
			var lastDraggable = currentDropData.lastDraggableAccepted.pop();
			var previousDragData = dndInfo.draggableData[lastDraggable];

			// swap droppable information if moving from one droppable to another
			if (currentDragData.currentDropID) {
				var previousDropData = dndInfo.droppableData[currentDragData.currentDropID];
				previousDropData.containedDraggables.push(lastDraggable);
				if (previousDropData.containedDraggables.indexOf($draggable[0].id) > -1) {
					previousDropData.containedDraggables.splice(
						previousDropData.containedDraggables.indexOf($draggable[0].id),
						1
					);
				}
				if (previousDropData.lastDraggableAccepted.indexOf($draggable[0].id) > -1) {
					previousDropData.lastDraggableAccepted.splice(
						previousDropData.lastDraggableAccepted.indexOf($draggable[0].id),
						1
					);
				}
				previousDropData.lastDraggableAccepted.push(lastDraggable);
				previousDragData.currentDropID = currentDragData.currentDropID;
				previousDragData.previousPosition = previousDragData.currentPosition;
				previousDragData.currentPosition = alignedPosition(
					$('#' + currentDragData.currentDropID),
					$('#' + lastDraggable)
				);
			} else {
				previousDragData.previousPosition = previousDragData.currentPosition;
				previousDragData.currentPosition = currentDragData.currentPosition;
			}
			// add draggable data to droppable and remove the data of the draggable being swapped
			currentDropData.containedDraggables.push($draggable[0].id);
			if (currentDropData.containedDraggables.indexOf(lastDraggable) > -1) {
				currentDropData.containedDraggables.splice(
					currentDropData.containedDraggables.indexOf(lastDraggable),
					1
				);
			}
			currentDropData.lastDraggableAccepted.push($draggable[0].id);
			// update new and old draggable dropID
			previousDragData.currentDropID = currentDragData.currentDropID;
			currentDragData.currentDropID = $droppable[0].id;

			// swap positions. The draggable being removed will move to the current position the new draggable was moved from and the new draggable will now be in the drop area

			currentDragData.previousPosition = currentDragData.currentPosition;
			currentDragData.currentPosition = alignedPosition($droppable, $draggable);
			// move both draggables
			$draggable.animate(currentDragData.currentPosition, 500);
			$('#' + lastDraggable).animate(previousDragData.currentPosition, 500);
		}
	}

	return true;
} //end handleDrop

function checkDnd() {
	var $droppables = globalVar.$curSlide.find('.droppable');
	var isCorrect = true;
	$droppables.each(function (idx, droppable) {
		var currentDroppableData = slides[globalVar.curSlide].dnd.droppableData[droppable.id];
		var submittedAnswer = currentDroppableData.containedDraggables;
		var correctAnswers = currentDroppableData.answers;

		if (!isCorrect) {
			return isCorrect;
		}
		switch (typeof correctAnswers) {
			case 'string':
				switch (correctAnswers) {
					case 'empty':
						if (submittedAnswer.length > 0) {
							isCorrect = false;
							return;
						}
						break;
					case 'any':
						if (submittedAnswer.length === 0) {
							isCorrect = false;
							return;
						}
						break;
					default:
						break;
				}
				break;
			case 'number':
				if (submittedAnswer.length !== correctAnswers) {
					isCorrect = false;
					return;
				}

				break;
			case 'boolean':
				isCorrect = correctAnswers;
				return;
			case 'object':
				if (Array.isArray(correctAnswers)) {
					if (correctAnswers.length !== submittedAnswer.length) {
						isCorrect = false;
						return;
					}
					var sortedCorrectAnswer = correctAnswers.sort();
					var sortedSubmittedAnswer = submittedAnswer.sort();
					isCorrect = sortedCorrectAnswer.every(function (answer, idx) {
						return sortedSubmittedAnswer[idx] === answer;
					});
					return isCorrect;
				} else {
					for (answerKey in correctAnswers) {
						var sortedAnswerArray = correctAnswers[answerKey].sort();
						var sortedSubmittedArray = submittedAnswer.sort();
						if (sortedAnswerArray.length !== sortedSubmittedArray.length) {
							isCorrect = false;
							continue;
						}

						isCorrect = sortedAnswerArray.every(function (answer, idx) {
							return sortedSubmittedArray[idx] === answer;
						});
						if (isCorrect) {
							return;
						} else {
							continue;
						}
					}
				}
				break;
			default:
				break;
		}
	});

	return isCorrect;
} //end checkDnd
function keyBoardAccess(dragElement) {
	var accessibility = function (event) {
		var drops = globalVar.$curSlide.find('.droppable');
		var dropIdx = 0;
		var $drag = $(this);
		if (event.which === 32) {
			//spacebar selects drag element

			$(drops[dropIdx]).focus(); //focuses on first drop area
			$drag.off('keydown.access'); //removes spacebar selector
			dragging($drag[0]); //takes care of drag events

			$('body').on('keydown.drag', function (event) {
				switch (event.keyCode) {
					case 9: //removes ability to tab while drag element is selected
						event.preventDefault();
						break;
					case 27: // allows user to press escape key to return to normal and places focus on drag element
						$drag.animate(
							{
								top: $drag.data('originalTop'),
								left: $drag.data('originalLeft')
							},
							revertTime
						);
						$drag.focus();

						$drag.on('keydown.access', accessibility);
						$('body').off('keydown.drag');
						break;
					case 38: //up arrow cycles through drop targets
						if (dropIdx < drops.length - 1) {
							dropIdx += 1;
						} else {
							dropIdx = 0;
						}
						$(drops[dropIdx]).focus();
						break;
					case 40: //down arrow cycles through drop targets
						if (dropIdx > 0) {
							dropIdx -= 1;
						} else {
							dropIdx = drops.length - 1;
						}
						$(drops[dropIdx]).focus();
						break;
					case 13: //enter key drops selected drag element into currently focused drop area
						dropped(drops[dropIdx], $drag[0]);
						if (slides[globalVar.curSlide].dnd.type === 'dnd_2') {
							$drag.blur();
						} else {
							$drag.focus();
						}
						$drag.on('keydown.access', accessibility);
						$('body').off('keydown.drag');
						break;
					default:
						return true;
				}
			});
		}
	};
	$(dragElement).on('keydown.access', accessibility);
}

function resetLeaderLines(slide) {
	// console.log('reset');
	for (var lineNameKey in leaderlines[globalVar.curSlide]) {
		leaderlines[globalVar.curSlide][lineNameKey].hide('draw');
	}
	setTimeout(function () {
		for (var lineNameKey2 in leaderlines[globalVar.curSlide]) {
			leaderlines[globalVar.curSlide][lineNameKey2].setOptions({
				end: leaderlines[globalVar.curSlide][lineNameKey2].originalEndPoint,
				endPlug: 'behind'
			});
		}
	}, 500);
}
function quickResetLeaderLines(slide) {
	// console.log('quick reset');
	for (var lineNameKey in leaderlines[slide]) {
		leaderlines[slide][lineNameKey].hide('none');
	}
	setTimeout(function () {
		for (var lineNameKey2 in leaderlines[slide]) {
			leaderlines[slide][lineNameKey2].setOptions({
				end: leaderlines[slide][lineNameKey2].originalEndPoint,
				endPlug: 'behind'
			});
		}
	}, 500);
}
function resetSpecificLeaderLine(line) {
	// console.log(id);
	// leaderlines[globalVar.curSlide][id].hide('draw');
	leaderlines[globalVar.curSlide][line].hide('draw');

	setTimeout(function () {
		leaderlines[globalVar.curSlide][line].setOptions({
			end: leaderlines[globalVar.curSlide][line].originalEndPoint,
			endPlug: 'behind'
		});
	}, 500);
}
